import {Head} from '@shopify/hydrogen';

export default function ServerError() {
  return (
    <>
      <Head>
        <title>Server Error - The Whisky List</title>
      </Head>

      <div className="error-page">
        <div className="wrapper">
          <div className="box-cont">
            <h3>500 Error</h3>
            <h4>Looks like we&apos;re having some server issues.</h4>
            <div className="line-divider"></div>
            <p>
              Go back to the previous page and try again. Or if you think
              something is broken, please report the problem.
            </p>

            <div className="btn-cont">
              <a
                className="button"
                href="mailto:cheers@thewhiskylist.com.au"
                target="_blank"
                rel="noreferrer"
              >
                Report a problem
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
